import styles from '@/styles/productDetail/productInfo.module.scss'
import { useState, useEffect, useRef } from 'react'
import { SideBySideMagnifier as Magnifier } from 'react-image-magnifiers';
// 强制类型断言，绕过类型不匹配的问题
const SideBySideMagnifier = Magnifier as unknown as React.FC<any>;
import MyTags from "@/components/MyTags"
import Down from '@/svgs/down.svg'
import Right from '@/svgs/right.svg'
import PaymentLogoAfterpay from '@/svgs/payment-logo-afterpay.svg'
import MyWishlist from '@/svgs/my-wishlist.svg'
import MyWishlistClick from '@/svgs/my-wishlist-click.svg'
import ShippingSave from '@/svgs/shipping-save.svg'
import IconHelp from '@/svgs/icon-help.svg'
import IconSuccessful from '@/svgs/successful.svg'
import ClockIcon from '@/svgs/clock-icon.svg'
import useCartActions from '@/utils/addTocartAction'
import { getToken } from '@/utils/auth'
import { debounce, formatCurrency } from "@/utils/utils"

import NotifyMe from './NotifyMe'
import Wholesale from "./Wholesale"

import { Rate, Select, Button, Input, Popover, message, Modal, Spin } from 'antd'
import Link from 'next/link'
import Image from 'next/image'

import getConfig from 'next/config'

import productApi from '@/service/modules/productApi'
import AddToCartSuccessModal from '../AddToCartSuccessModal'
import SuburbSelect from '../SuburbSelect';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import ZipSvg from "@/svgs/pay/icon-payment-logo-zip.svg";
import SwiperSelf from '../SwiperSelf';
import { SwiperSlide } from 'swiper/react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
const apiDomain = publicRuntimeConfig.apiDomain

interface PictureItem {
  thumbnailUrl: string;
  imageHDUrl: string;
  imageORUrl: string;
  fileNameUrl: string;
  isDefault: number;
}

interface ReviewData {
  avgRank: number;
  total: number;
  summary: any;
}

interface paymentMethodItem {
  paymentName: string;
  paymentIcon: string;
}

interface variantProductsItem {
  productID: number;
  name: string;
  thumbnail: string;
  defaultMember: number;
  url: string;
  options: { optionID: number; variantID: number }[]; // 内联Option对象数组
}

interface ProductDetailData {
  name: string;
  productID: number;
  categoryID: number;
  url: string;
  enabled: number;
  discontinued: number;
  price: number;
  promotionPrice: number;
  normalPrice: number;
  promotionTypeID: string | number | undefined;
  inStock: number;
  courierID: number;
  freeShipping: number;
  preSales: number;
  preSalesDate: string;
  isDropShipping?: number;
  isEmailOnly: boolean;
  isNew: number | undefined;
  isGroup: number;
  onSale: number;
  reduced: number;
  pictures: PictureItem[];
  firstMagnifierImage?: string;
  newThumbnail: string;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status: number;
    notified: number;
    pointRate: string;
    discountPercent: string;
    ebaySync: number;
  };
  emailOnlyFinished: number;
  currentTime: string;
  warehouseID: number;
  variants: {
    options: any;
    products: variantProductsItem[];
  },
  features?: string;
}

interface QuantityOptions {
  value: number;
  label: string | number;
}

interface Props {
  displayPurposesOnly?: Boolean; // 是否仅展示使用（类似csotd页）
  productDetailData?: ProductDetailData | null;
  review: ReviewData | null | undefined;
  paymentMethod?: paymentMethodItem[];
  quantityNum: number;
  handleQuantityChange: Function;
  quantityOptions: QuantityOptions[];
}

export default function ProductInfo({ displayPurposesOnly, productDetailData, review, paymentMethod, quantityNum, handleQuantityChange, quantityOptions }: Props) {
  const swiperSlidesPerView = 5
  const { addToCart } = useCartActions();
  const [isHdImage, setIsHdImage] = useState(false)
  const [imageIndex, setImageIndex] = useState(0)
  const [hasChangeImage, setHasChangeImage] = useState(false)
  const [selectedImage, setSelectedImage] = useState({ thumbnailUrl: '', imageHDUrl: '', imageORUrl: '', fileNameUrl: '' })
  const [showDynamicComponents, setShowDynamicComponents] = useState(false)
  const [showSideBySideMagnifier, setShowSideBySideMagnifier] = useState(false)
   const [isSwiperBegin, setSwiperBegin] = useState(true)
  const [isSwiperEnd, setSwiperEnd] = useState((productDetailData?.pictures && productDetailData?.pictures.length > swiperSlidesPerView) ? false : true)
  const [swiperReady, setSwiperReady] = useState(false);
    const swiper: any = useRef(null);
  // 切换商品图, 更换大图数据
  function handleChangeImage(item: any, index: number) {
    if (!hasChangeImage) {
      preloadImages()
    }

    setHasChangeImage(true)
    setImageIndex(index)
    setIsHdImage(!!item.imageHDUrl)
    setSelectedImage(item)
  }
  // 预加载商品大图
  const preloadImages = () => {
    if (productDetailData?.pictures && productDetailData.pictures.length) {
      const imagesToPreload = productDetailData.pictures.map((item: any) => item.imageHDUrl || item.imageORUrl || item.fileNameUrl)        

      imagesToPreload.forEach((image) => {
        const preloadLink = document.createElement('link')
        preloadLink.href = image
        preloadLink.rel = 'preload'
        preloadLink.as = 'image'

        document.head.appendChild(preloadLink)
      })
    }
  }
    // 切换swiper页数
  const slideChange = (isBeginning: boolean, isEnd: boolean, index: number) => {
    setSwiperBegin(isBeginning)
    setSwiperEnd(isEnd)
    // if (productDetailData?.pictures && productDetailData?.pictures[index]) {
    //   handleChangeImage(productDetailData.pictures[index], index)
    // }
  }

  // 修改postcode
  const defaultSuburbID = useSelector((state: RootState) => state.userInfo.data.suburbID);
  const defaultSuburbName = useSelector((state: RootState) => state.userInfo.data.suburb);
  const [suburbId, setSuburbId] = useState<any>("")
  const [suburbName, setSuburbName] = useState<string>("")
  const [postageLoading, setPostageLoading] = useState(false)
  const [postcodeNotAvailable, setPostcodeNotAvailable] = useState(false)
  const [shippingError, setShippingError] = useState(false)
  const [shippingDistanceError, setShippingDistanceError] = useState(false)

  // 监听鼠标移动事件，仅在首次移动时触发放大镜组件加载
  useEffect(() => {
    const handleMouseMove = () => {
      setShowDynamicComponents(true);

      // 2秒之后，开始展示放大图组件
      setTimeout(() => {
        setShowSideBySideMagnifier(true)
      }, 2000);

      window.removeEventListener('mousemove', handleMouseMove);
    };
    window.addEventListener('mousemove', handleMouseMove);

    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  useEffect(() => {
    if (defaultSuburbID) {
      setSuburbId(parseInt(`${defaultSuburbID}`))
      setSuburbName(defaultSuburbName)
    }
  }, [defaultSuburbID])

  const suburbChange = (data: any, option: any) => {
    setSuburbId(data)
    setSuburbName(option.name)
  } 

  // 监听suburb，触发更新邮费
  useEffect(() => {
    console.log(suburbId);
    
    if (suburbId) {
      calculatePostage()
    }
  }, [suburbId])

  // 监听quantityNum，触发更新邮费
  useEffect(() => {
    if (quantityNum) {
      calculatePostage()
    }
  }, [quantityNum])

  // 计算邮费
  interface PostageData {
    courier: string;
    courierId: string;
    dTime: string;
    itemError: string;
    postage: number | string;
    productID: string;
    quantity: number;
    eta: string;
  }
  const initialPostageData: PostageData = {
    courier: '',
    courierId: '',
    dTime: '',
    itemError: '',
    postage: '',
    productID: '',
    quantity: 1,
    eta:''
  };

  const [showAddToCartModal, setShowAddToCartModal] = useState(false)
  
  const [postageData, setPostageData] = useState<PostageData>(initialPostageData);
  // 获取邮费数据
  const calculatePostage = async() => {

    // 没有选中currentSuburb，不请求
    if (!suburbId) return

    try {
      setPostageLoading(true)
      let dataObj = {
        suburb: suburbName,
        suburbID: suburbId,
        productID: productDetailData?.productID,
        quantity: quantityNum,
      }
      let res = await productApi.getShippingData(dataObj)
      setPostageLoading(false)
      setShippingDistanceError(false)
      setShippingError(false)
      if (res.data) {
        setPostageData(res.data)
      }
    } catch (error: any) {
      if (error.code == 150002) {
        setShippingDistanceError(true)
        setShippingError(false)
      } else {
        setShippingDistanceError(false)
        setShippingError(true)
      }
      setPostageLoading(false)
      setPostageData(initialPostageData)
    }
  }

  // 评论相关的浮层
  const reviewsPopoverTitle = (
    <div className={styles['reviews-popover-title']}>
      {/* <b>{productDetailData?.review?.avgRank} </b>Out of 5 */}
    </div>
  )

  let starProgressList = [
    { star: 5, reviewsNum: review?.summary.rating5 },
    { star: 4, reviewsNum: review?.summary.rating4 },
    { star: 3, reviewsNum: review?.summary.rating3 },
    { star: 2, reviewsNum: review?.summary.rating2 },
    { star: 1, reviewsNum: review?.summary.rating1 }
  ]

  starProgressList.forEach((item: any) => {
    let reviewsTotal: number | undefined = review?.total || 0
    item.percent = (review?.summary[`rating${item.star}`] || 0) / reviewsTotal
  })

  // 去查看所有reviews
  const handleViewAllReviews = () => {
    window.location.href = `${apiDomain}/product/${productDetailData?.productID}/reviews/`
  }

  const reviewsPopoverContent = (
    <div className={styles['reviews-popover-content']}>
      <div className={styles['star-progress-rate']}>
        {
          starProgressList.map((item: any, index: number) => (
            <div className={styles['item']} key={index}>
              <div className={styles['star']}>{item.star} Star</div>
              <div className={styles['progress-box']}>
                <div
                  style={{ width: `${item.percent >= 1 ? 1 * 100 : item.percent * 100}%` }}
                className={styles['progress-line']}></div>
              </div>
              <div className={styles['reviews-num']}>({item.reviewsNum})</div>
            </div>
          )) 
        }
      </div>

      <div className={styles['view-all-reviews']} onClick={handleViewAllReviews}>
        View all {review?.total} Reviews
        <Right style={{ width: '12px', marginLeft: '4px' }}></Right>
      </div>
    </div>
  )

  // PRE-ORDER NOW
  function preOrderNow() {
    const href = encodeURIComponent(`/checkout?p=${productDetailData?.productID}&t=${quantityNum}`)
    if (getToken() == '1') {
      window.location.href = `/checkout?p=${productDetailData?.productID}&t=${quantityNum}`
    } else {
      window.location.href = `/login?redirect=${href}`
    }
  }

  // 商品加购
  const [buyNowLoading, setBuyNowLoading] = useState(false)
  const [addCartBtnLoading, setAddCartBtnLoading] = useState(false)
  const addToCartCallBack = (response: any, goCart?: boolean) => {
    if (response != "error") {
      goCart
      ?
      window.location.href = '/checkout'
      :
      setShowAddToCartModal(true)
    }
    setAddCartBtnLoading(false)
    setBuyNowLoading(false)
  }
  
  // 加入wishlist
  const [isWish, setIsWish] = useState(false)
  const [wpid, setWpid] = useState(0)
  const [addWishlistLoading, setAddWishlistLoading] = useState(false)
  const [showWishSuccessModal, setShowWishSuccessModal] = useState(false)
  const [showWishLoginModal, setShowWishLoginModal] = useState(false)


  const handleShowWishSuccessModal = () => {
    setShowWishSuccessModal(true)
  }
  const handleCancelWishSuccessModal = () => {
    setShowWishSuccessModal(false)
  }

  const handleShowWishLoginModal = () => {
    setShowWishLoginModal(true)
  }
  const handleCancelWishLoginModal = () => {
    setShowWishLoginModal(false)
  }

  const handleLogin = () => {
    const currentPath = window.location.pathname + window.location.search;
    const encodedRedirect = encodeURIComponent(currentPath);

    window.location.href = `${apiDomain}/login?redirect=${encodedRedirect}`;
  }

  // 获取是否有加入wishlist
  useEffect(() => {
    const getWishData = async() => {
      try {
        let res = await productApi.getIsWishByProduct(productDetailData?.productID)
        if (res.data) {
          setIsWish(!!res.data.isWish)

          // 保存下商品的心愿单id。后续remove操作用得上
          if (res.data.isWish) setWpid(res.data.wpid)
        }
      } catch (error) {
        console.error(error)
      }
    }
    // 延迟获取是否加入心愿单
    setTimeout(() => {
      if (getToken() == '1') {
        getWishData()
      }
    }, 1000)
  }, [])

  // 获取是否有加入wishlist
  const handleToggleWish = async() => {
    if (isWish) {
      try {
        if (!wpid) {
          message.error('System Error')
          return
        }

        setAddWishlistLoading(true)
        let res = await productApi.removeWishList(wpid)
        if (res.data) {
          message.success('Removed successfully.')
          setIsWish(false)
          setWpid(0)
          setAddWishlistLoading(false)
        }
      } catch (error: any) {
        message.error(error.message)
        setAddWishlistLoading(false)
      }
    } else {
      try {
        if (getToken() != '1') {
          // 未登录状态，不允许请求加入心愿单。弹起登录弹窗
          handleShowWishLoginModal()
          return
        }

        setAddWishlistLoading(true)
        let res = await productApi.addWishList({ productID: productDetailData?.productID })
        if (res.data) {
          setIsWish(true)
          setWpid(res.data.wishProductID)
          handleShowWishSuccessModal()
          setAddWishlistLoading(false)
        }
      } catch (error: any) {
        message.error(error.message)
        setAddWishlistLoading(false)
      }
    }
  }

  // 判断是否有myTags，没有内容的话，PID的文字要靠左
  useEffect(() => {
    // 获取myTagsBox元素
    const myTagsBox: HTMLElement | null = document.getElementById('myTagsBox');

    // 获取productId元素
    const productId: HTMLElement | null = document.getElementById('productId');

    if (myTagsBox && productId) {
      // 获取myTagsBox元素的宽度
      const myTagsBoxWidth: number = myTagsBox.offsetWidth;

      // 检查宽度是否小于20px
      if (myTagsBoxWidth < 20) {
        // 如果宽度小于20px，为productId元素添加margin-left: -16px样式
        productId.style.marginLeft = '-16px';
      }
    }
  }, [])

  // 跳转到商品详情页面
  const handleViewProductDetail = () => {
    window.location.href = `${apiDomain}${productDetailData?.url}${quantityNum > 1 ? '?quantity=' + quantityNum : ''}`
  }

  // afterpay弹窗
  const [showAfterpayModal, setShowAfterpayModal] = useState(false);
  const handleShowAfterpayModal = () => {
    setShowAfterpayModal(true)
  }
  const handleCancelAfterpayModal = () => {
    setShowAfterpayModal(false)
  }

  // 弹窗
  const [showCombineModal, setShowCombineModal] = useState(false);
  const handleShowCombineModal = () => {
    setShowCombineModal(true)
  }
  const handleCancelCombineModal = () => {
    setShowCombineModal(false)
  }

  // 批发佬弹窗控制
  const [isWholesaleOpen, setIsWholesaleOpen] = useState(false);
  const openWholesale = () => {
    setIsWholesaleOpen(true);
  };

  const closeWholesale = () => {
    setIsWholesaleOpen(false);
  };

  // notifyMe弹窗控制
  const [isNotifyMeOpen, setisNotifyMeOpen] = useState(false);
  const openNotifyMe = () => {
    setisNotifyMeOpen(true);
  };

  const closeNotifyMe = () => {
    setisNotifyMeOpen(false);
  };

  // 多规格属性, 元素接口
  interface SpecOptionItem {
    optionValue: string;
    additionalValue: string;
    optionID: number;
    variantID: number;
  }
  interface SpecOptionType {
    name: string;
    defaultVariant: number;
    optionID: number;
    options: SpecOptionItem[] | undefined;
  }
  const [multipleSpecList, setMultipleSpecList] = useState<SpecOptionType[]>([]);

  // 多规格属性 配置初始化
  useEffect(() => {
    if (productDetailData?.variants && productDetailData?.variants.options) {
      // 提取所有选项到一个数组
      let optionsArray: SpecOptionType[] = []

      if (productDetailData?.variants.options) {
        const optionKeys = Object.keys(productDetailData.variants.options);
      
        optionKeys.forEach(key => {
          if (productDetailData.variants.options[key].length) {
            optionsArray.push({
              name: key,
              defaultVariant: 0,
              optionID: productDetailData.variants.options[key][0].optionID,
              options: productDetailData.variants.options[key]
            });
          }
        });
      }

      // 选中variants.products里面产品ID相同的options，赋值。没得赋值就添加一个选项：Please Select
      let target = productDetailData?.variants.products.filter((item: any) => item.productID == productDetailData.productID)
      if (target.length && target[0].options) {
        target[0].options.forEach((option: any) => {
          if (optionsArray && optionsArray.length) {
            optionsArray.forEach((spec: SpecOptionType) => {
              if (option.optionID == spec.optionID) {
                spec.defaultVariant = option.variantID
              }
            })
          }
        })
      } else if (target.length && (!target[0].options || target[0].options.length <= 0)) {
        // 如果没有默认值（数据原因），则加上Please Select选项
        optionsArray.forEach((spec: SpecOptionType) => {
          spec.options?.unshift({ 
            optionValue: 'Please Select',
            additionalValue: '#008000',
            optionID: spec.optionID,
            variantID: 0
          })
        })
      }

      setMultipleSpecList(optionsArray)
    }
  }, [])

  // 触发更新Spec，跳转到对应的链接
  const handleChangeSpec = (optionID: any, value: number) => {
    // 先复制一份商品列表出来，格式化为前端容易做匹配的格式
    let specProduct = JSON.parse(JSON.stringify(productDetailData?.variants.products))

    // 遍历当前选中值的集合，方便后面做匹配
    let selectedOptions = multipleSpecList.map(item => {
      return {
        optionID: item.optionID,
        variantID: item.defaultVariant
      }
    })

    // 把刚刚选中的值，更新到selectedOptions
    selectedOptions.forEach(item => {
      if (item.optionID == optionID) {
        item.variantID = value
      }
    }) 

    // 存储匹配的结果 productUrl
    let matchingProductUrl = null;

    // 遍历产品数据，有结果就赋值给matchingProductUrl
    for (const product of specProduct) {
      const productOptions = product.options;
      
      // 检查 productOptions 是否为空
      if (!Array.isArray(productOptions) || productOptions.length === 0) {
        continue; // 如果 productOptions 为空，跳过该产品
      }

      // 检查当前产品的选项是否与选中值匹配
      if (selectedOptions.every(selectedOption => (
        productOptions.some((productOption: any) =>
          productOption.optionID === selectedOption.optionID &&
          productOption.variantID === selectedOption.variantID
        )
      ))) {
        matchingProductUrl = product.url;
        break; // 找到匹配后，立即停止遍历
      }
    }

    // 跳转到选中的URL
    if (matchingProductUrl) {
      window.location.href = matchingProductUrl;
    }
  }
  const ref1 = useRef<HTMLDivElement>(null);
  const ref2 = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const listener = (e: WheelEvent) => {
      e.preventDefault();
    };
    const popup1 = ref1.current;
    const popup2 = ref2.current;
    if (open) {
      popup1?.addEventListener("wheel", listener);
      popup2?.addEventListener("wheel", listener);
    }

    return () => {
      popup1?.removeEventListener("wheel", listener);
      popup2?.removeEventListener("wheel", listener);
    };
  }, [open]) 


  // 商品销售状态管理，return对应的操作按钮
  const StockStatusBtn = () => {
    if (productDetailData?.preSales) {
      return (
        // 预售按钮
        <Button 
          className={styles['pre-sales-btn']}
          type="primary"
          onClick={preOrderNow}
        >
          PRE-ORDER NOW
        </Button>
      )
    } else {
      if (productDetailData?.inStock && productDetailData?.enabled) {
        // 正常可购买
        return (
          <>
            <Button
              type="primary"
              className={styles['add-cart']}
              loading={buyNowLoading}
              onClick={(event) => {
                setBuyNowLoading(true);
                addToCart(event, {
                  productID: productDetailData.productID,
                  qty: quantityNum,
                }, (res: any) => { addToCartCallBack(res, true) })
              }}
            >
              Buy Now
            </Button>
            <Button
              loading={addCartBtnLoading}
              style={{ fontWeight: 'bold', marginRight: 8, borderColor:'#E6415F',color:'#E6415F' }}
              onClick={(event) => {
                setAddCartBtnLoading(true);
                addToCart(event, {
                  productID: productDetailData.productID,
                  qty: quantityNum,
                }, addToCartCallBack)
              }}
            >
              Add to Cart
            </Button>
          </>
        )
      } else if (!productDetailData?.enabled && productDetailData?.discontinued) {
        return (
          <Button 
            className={styles['add-cart']}
            type="primary"
          >
            Unavailable
          </Button>
        )
      } else {
        return (
          <Button 
            className={styles['add-cart']}
            type="primary"
            onClick={openNotifyMe}
          >
            Notify Me
          </Button>
        )
      }
    }
  };

  return (
    <div className={styles['product-box']}>
      <div className={styles['product-img-box']}>
          <div className={styles['magnifier-box']}>
            {
              !showSideBySideMagnifier
              ?
              <Image
                className={`${styles['default-img']}`}
                src={ !hasChangeImage ? productDetailData?.firstMagnifierImage || '' : isHdImage ? selectedImage.imageHDUrl : selectedImage.imageORUrl || selectedImage.fileNameUrl }
                alt={productDetailData?.name || ''}
                priority={true}
                width={564}
                height={564}
              /> 
              :
              null
            }
            {
              showDynamicComponents
              ?
              <SideBySideMagnifier
                  imageSrc={ !hasChangeImage ? productDetailData?.firstMagnifierImage || '' : isHdImage ? selectedImage.imageHDUrl : selectedImage.imageORUrl || selectedImage.fileNameUrl }
                  largeImageSrc={ !hasChangeImage ? productDetailData?.firstMagnifierImage || '' : isHdImage ? selectedImage.imageHDUrl : selectedImage.imageORUrl || selectedImage.fileNameUrl }
                  imageAlt={productDetailData?.name}
                  fillAvailableSpace={false}
                  zoomContainerBorder={'1px solid #dddddd'}
                  overlayBoxColor={'#dddddd'}
                />
              :
              null
            }
          </div>

        <div className={styles['small-img-box']}>
          <SwiperSelf
            slidesPerView={swiperSlidesPerView}
            slidesPerGroup={1}
            autoplay={false}
            hideArrows={true}
            spaceBetween={10}
            speed={800}
            ref={swiper}
            slideChange={slideChange}
            swiperOnInit={() => { setSwiperReady(true) }}
          >
            {productDetailData?.pictures.slice(0, 12).map((item: PictureItem, index: number) => (
              <SwiperSlide key={index}>
                <div
                  className={`${styles['small-img-item']} ${imageIndex === index ? styles['active'] : ''}`}
                >
                  <Image
                    className={`${styles['small-img']}`}
                    src={item.thumbnailUrl}
                    alt={productDetailData?.name}
                    priority={true}
                    width={85}
                    height={85}
                    onMouseOver={debounce(() => handleChangeImage(item, index), 100)}
                  />
                </div>
              </SwiperSlide>
            ))}
          </SwiperSelf>
          {
            !!(swiperReady && !isSwiperBegin)
            &&
            <div className={styles['swiper-left']} onClick={() => swiper.current?.slidePrev()}>
              <LeftOutlined />
            </div>
          }

          {
            !!(swiperReady && !isSwiperEnd)
            &&
            <div className={styles['swiper-right']} onClick={() => swiper.current?.slideNext()}>
              <RightOutlined />
            </div>
          }
        </div>

        {
          productDetailData?.warehouseID === 100002
          &&
          <div className={styles['contact-us']}>
            Wholesale prices are available,
            <span className={styles['link']} onClick={openWholesale}>contact us</span>
            for more discounts on bulk buys.
          </div>
        }

      </div>

      <div className={styles['product-info']}>
        <div className={styles['product-id-box']}>
          <div style={{ marginRight: '16px' }} id="myTagsBox">
            <MyTags {...{ 
              ...productDetailData,
              isSingle: true,
              isNew: productDetailData?.isNew || 0,
              isEmailOnly: productDetailData?.isEmailOnly || 0,
              promotionTypeID: productDetailData?.promotionTypeID || undefined,
            }} />
          </div>
          <div className={styles['product-id']} id="productId">PID:&nbsp;{ productDetailData?.productID }</div>
        </div>

        <Popover
          content={(
            <div style={{ width: '500px' }}>{productDetailData?.name}</div>
          )}
          placement="top"
          trigger="hover"
        >
          <div className={styles['product-name']}>
            { productDetailData?.name }
          </div>
        </Popover>

        <div className={styles['reviews-box']}>
          <div className={styles['reviews-title']}>Overall Rating:</div>

          <Popover
            title={reviewsPopoverTitle}
            content={reviewsPopoverContent}
            placement="bottom"
            trigger="hover"
          >
            <div 
              style={{ 
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <Rate style={{ color: '#ffc33d', paddingBottom: '2px', fontSize: '16px', marginRight: '8px' }} allowHalf disabled value={review?.avgRank || 5} />
              <Down style={{ width: '12px', cursor: 'pointer' }}></Down>
              <div className={styles['reviews-count']}>{review?.total} Reviews</div>
            </div>
          </Popover>
        </div>

        <div className={styles['price-box']}>
          {
            !!(productDetailData?.inStock && productDetailData?.price != productDetailData?.normalPrice)
            &&
            <div className={styles['title']}>WAS: ${productDetailData?.normalPrice}</div>
          }

          <div 
            className={styles['price-line']}
            style={{ marginBottom: displayPurposesOnly ? '16px' : '0px' }}
          >
            <div className={styles['price-unit']} style={{color:productDetailData?.inStock?'#e6415f':'#666'}}>$</div>
            <div className={styles['price-integer']} style={{color:productDetailData?.inStock?'#e6415f':'#666'}}>{productDetailData?.price.toString().split('.')[0]}.</div>
            <div className={styles['price-float']} style={{color:productDetailData?.inStock?'#e6415f':'#666'}}>{productDetailData?.price.toString().split('.')[1] || '00'}</div>
            {
              !!(productDetailData?.normalPrice && productDetailData.normalPrice != productDetailData?.price)
              &&
              <>
                {
                  (productDetailData.promotion.promotionType == 6 && !productDetailData.emailOnlyFinished)
                  ?
                  <div className={styles['email-only-sign']}>Email Only</div>
                  :
                  <>
                    {
                      (productDetailData.normalPrice - productDetailData?.price >= 100)
                      ?
                      <div className={styles['discount']}>Save ${(productDetailData.normalPrice - productDetailData?.price).toFixed(2)}</div>
                      :
                      <div className={styles['discount']}>{(((productDetailData.normalPrice - productDetailData.price) / productDetailData.normalPrice) * 100).toFixed(0)}% OFF</div>
                    }
                  </>
                }
              </>
            }
          </div>
          {
            !!(!displayPurposesOnly && productDetailData?.price)
            &&
            <div className={styles['afterpay-box']}>
              <div className={styles['afterpay-benefit']}>or 4 interest free payments of  { (productDetailData.price / 4).toFixed(2) } with </div>
              <PaymentLogoAfterpay
                style={{ width: '78px', cursor: 'pointer'  }}
                onClick={handleShowAfterpayModal}
              ></PaymentLogoAfterpay>
              {
                showAfterpayModal &&
                <Modal
                  title=""
                  width={600}
                  centered
                  footer={null}
                  open={showAfterpayModal}
                  onCancel={handleCancelAfterpayModal}
                >
                  <div className={styles['afterpay-model']}>
                    <PaymentLogoAfterpay className={styles['logo']}></PaymentLogoAfterpay>
                    <div className={styles['title']}>buy now. pay later. interest-free.</div>

                    <div className={styles['afterpay-item-box']}>
                      <div className={styles['afterpay-item-icon-gimm']}></div>

                      <div>
                        <div className={styles['item-title']}>NO GIMMICKS</div>
                        <div className={styles['item-desc']}>Pay for your purchase over 4 instalments, due every two weeks.①</div>
                      </div>
                    </div>

                    <div className={styles['afterpay-item-box']}>
                      <div className={styles['afterpay-item-icon-hidd']}></div>

                      <div>
                        <div className={styles['item-title']}>NO INTEREST</div>
                        <div className={styles['item-desc']}>100% interest-free when you pay it in 4.②</div>
                      </div>
                    </div>

                    <div className={styles['afterpay-item-box']}>
                      <div className={styles['afterpay-item-icon-card']}></div>

                      <div>
                        <div className={styles['item-title']}>NO CARD APPLICATION</div>
                        <div className={styles['item-desc']}>No lengthy application. Online approval.</div>
                      </div>
                    </div>

                    <div className={styles['simply-checkout']}>
                      <h1 style={{ fontWeight:'bold',  fontSize: "18px" }}>All you need is</h1>
                      <p>Must be over 18 years old; Live in New Zealand;</p>
                      <p>Have a New Zealand debit or credit card .</p>
                      <p>Simply select <span style={{ fontWeight:'bold', color: '#1d94ce' }}>afterpay</span> at checkout.</p>
                      <div className={styles['afterpay-item-icon-infree']}></div>
                    </div>

                    <div className={styles['got-it']} onClick={handleCancelAfterpayModal}>Got it!</div>

                    <div className={styles['apply']}>
                      <Link 
                        href="https://www.afterpay.com/en-NZ/terms-of-service"
                        passHref
                        legacyBehavior
                      >
                        <a 
                          className={styles['apply-link']}
                          onClick={handleCancelAfterpayModal}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          Terms & Conditions
                        </a>
                      </Link>
                      apply.
                    </div>

                    <div className={styles['text']}>① For first time Afterpay customers the first payment will be made at the time of purchase, with payments over 6 weeks. Existing Afterpay customers first payment will be made in 14 days, with payments over 8 weeks. The full payment schedule will be provided to you at time of purchase.</div>
                    <div className={styles['text']}>② If you fail to have sufficient funds available for Afterpay to automatically deduct payment on due instalment dates you will be charged a late fee of $10 and if the installment payment remains overdue one week late, an additional $7 will be charged.</div>
                  </div>
                </Modal>
              }
              <ZipSvg style={{ width: 48, marginLeft: 8}} />
            </div>
          }
        </div>

        <div className={styles['spec-box']}>
          {/* 多规格属性 */}
          {
            !!(multipleSpecList && multipleSpecList.length) 
            &&
            <div className={styles['multiple-spec-box']}>
              {
                multipleSpecList.map((item: SpecOptionType, index: number) => (
                  <div className={styles['item']} style={{ marginBottom: '16px' }} key={`multiple${index}`}>
                    <div className={styles['label']}>{ item.name }:</div>
                    <Select
                      value={Number(item.defaultVariant)}
                      fieldNames={{
                        label: 'optionValue',
                        value: 'variantID'
                      }}
                      style={{ width: 160, marginRight: '16px' }}
                      onChange={(value: number) => { handleChangeSpec(item.optionID, value) }}
                      options={item.options}
                    />
                  </div>
                )) 
              }
            </div>
          }

          <div className={styles['item']}>
            <div className={styles['label']}>Quantity:</div>
            <Select
              value={quantityNum}
              style={{ width: 100 }}
              onChange={(value: number) => { handleQuantityChange(value) }}
              options={quantityOptions}
              disabled={!productDetailData?.preSales && !productDetailData?.inStock}
              dropdownRender={(menu) => <div ref={ref1}>{menu}</div>}
              onDropdownVisibleChange={setOpen}
            />
            <div className={styles['status-box']}>
              <div 
                className={`
                  ${styles['status-sign']} 
                  ${
                    !productDetailData?.preSales && productDetailData?.inStock && productDetailData?.inStock <= 5
                    ? styles['sign-almost-sold-out'] 
                    : ''
                  }
                  ${
                    !productDetailData?.preSales && !productDetailData?.inStock 
                    ? styles['sign-sold-out'] 
                    : ''
                  }
                `}
              ></div>
              {!!(productDetailData?.preSales) &&
                <div className={styles['status-text']}>Pre-order </div>
              }
              {!!(!productDetailData?.preSales && productDetailData?.inStock && productDetailData.inStock > 5) &&
                <div className={styles['status-text']}>In Stock</div>
              }
              {!!(!productDetailData?.preSales && productDetailData?.inStock && productDetailData.inStock <= 5) &&
                <div className={styles['status-text']}>Almost Sold out</div>
              }
              {!!(!productDetailData?.preSales && !productDetailData?.inStock) &&
                <div className={styles['status-text']}>Sold out</div>
              }
            </div>
          </div>
        </div>

        {
          displayPurposesOnly
          ?
          <div className={styles['btn-box']}>
            <div
              className={styles['grab-it-now']}
              onClick={handleViewProductDetail}
            >
              <ClockIcon width={'24px'} style={{ marginRight: '12px' }}></ClockIcon>
              Grab It Now!
            </div>
          </div>
          :
          <div className={styles['btn-box']}>
            {/* {
              !!(productDetailData?.preSales) &&
              <Button 
                className={styles['pre-sales-btn']}
                type="primary"
                onClick={preOrderNow}
              >
                PRE-ORDER NOW
              </Button>
            }
            
            {
              !!(!productDetailData?.preSales && productDetailData?.inStock) &&
              <Button 
                type="primary"
                className={styles['add-cart']}
                loading={addCartBtnLoading}
                onClick={(event) => { 
                  setAddCartBtnLoading(true);
                  addToCart(event, { 
                    productID: productDetailData.productID,
                    qty: quantityNum,
                  }, addToCartCallBack) }}
              >
                Add to Cart
              </Button>
            }
            
            {
              !!(!productDetailData?.preSales && !productDetailData?.inStock) &&
              <Button 
                className={styles['add-cart']}
                type="primary"
                onClick={openNotifyMe}
              >
                Notify Me
              </Button>
            }
          
            {
              !!(productDetailData?.discontinued && !productDetailData?.enabled && !productDetailData?.inStock) &&
              <Button 
                className={styles['add-cart']}
                type="primary"
              >
                Unavailable
              </Button>
            } */}

            {/* 商品状态的对应按钮 */}
            <StockStatusBtn></StockStatusBtn>


            {/* 加入心愿单 */}
            <Button 
              className={styles['add-wishlist']}
              loading={addWishlistLoading}
              onClick={handleToggleWish}
            >
              {
                isWish
                ?
                <Popover content={'Remove from Wishlist'} trigger="hover">
                  <MyWishlistClick style={{ width: '27px', margin: '0 8px' }}></MyWishlistClick>
                </Popover>
                :
                <Popover content={'Add to Wishlist'} trigger="hover">
                  <MyWishlist style={{ width: '27px', margin: '0 8px' }}></MyWishlist>
                </Popover>
              }
            </Button>
          </div>
        }

        {
          showWishSuccessModal &&
          <Modal
            title=""
            width={696}
            centered
            footer={null}
            open={showWishSuccessModal}
            onCancel={handleCancelWishSuccessModal}
          >
            <div className={styles['wishlist-success-model']}>
              <div className={styles['title-box']}>
                <IconSuccessful style={{ width: '22px', marginRight: '16px' }}></IconSuccessful>
                This item has been added to your wishlist successfully!
              </div>

              <div className={styles['btn-box']}>
                <Button 
                  href="/my-account/wishlist"
                  className={styles['view-wishlist-btn']}
                  onClick={handleCancelWishSuccessModal}
                >
                  View Wish List
                </Button>

                <Button 
                  type="primary"
                  className={styles['continue-shopping-btn']}
                  onClick={handleCancelWishSuccessModal}
                >
                  Continue Shopping
                </Button>
              </div>
            </div>
          </Modal>
        }
        {
          showWishLoginModal &&
          <Modal
            title=""
            width={696}
            centered
            footer={null}
            open={showWishLoginModal}
            onCancel={handleCancelWishLoginModal}
          >
            <div className={styles['wishlist-success-model']}>
              <div className={styles['title-box']}>
                Please login to add product to your wishlist!
              </div>

              <div className={styles['btn-box']}>
                <Button 
                  type="primary"
                  className={styles['continue-shopping-btn']}
                  onClick={handleLogin}
                >
                  Confirm
                </Button>
              </div>
            </div>
          </Modal>
        }

        <div className={styles['payment-box']}>
          {/* crazypoints说明 */}
          {
            !displayPurposesOnly &&
            <Popover
              content={(
                <div>
                  1,00 BestDealsPoints=NZD $1<br/>
                  e.g. (Your BestDealsPoints) X 0.010 = NZD$ Value<br/>
                  * the BestDealsPoints can be applied in your next purchase
                </div>
              )}
              placement="bottom"
              trigger="hover"
            >
              <div className={styles['desc']}>
                Earn&nbsp;
                {
                  (productDetailData && productDetailData.promotion && productDetailData.promotion?.pointRate == '2.00')
                  ?
                  <>
                    <span>Double BestDealsPoints </span>
                    (Earn <span className={styles['price']}>{ productDetailData.price * (Number(productDetailData.promotion.pointRate) || 1) }</span> Points!)
                  </>
                  :
                  <>
                    <span className={styles['price']}>{ productDetailData?.promotion ? productDetailData.price * (Number(productDetailData?.promotion.pointRate) || 1) : productDetailData?.price }</span> BestDealsPoints!
                  </>
                }
                &nbsp;(<span className={styles['price']}>100</span> BestDealsPoints Equal <span className={styles['price']}>$1</span>)
              </div>
            </Popover>
          }
          <div className={styles['payment-list']}>
            {
              !!(paymentMethod && paymentMethod.length) 
              &&
              paymentMethod.map((item, index: number) => (
                <Image
                  key={index}
                  className={`${styles['payment-img']}`}
                  src={item.paymentIcon}
                  alt={item.paymentName}
                  width={57}
                  height={32}
                />
              ))
            }
          </div>
        </div>

        {/* 运费计算模块 */}
        {
          !displayPurposesOnly 
          &&
          <div className={styles['shipping-box']}>
            <div className={styles['title']}><span style={{ fontWeight:'bold' }}>Enter</span>&nbsp;and&nbsp;<span style={{ fontWeight:'bold' }}>Choose</span>&nbsp;Your Suburb to Check the Postage</div>

            <div className={styles['postcode-suburb']}>
              <SuburbSelect value={suburbId} onChange={suburbChange} notAutoSelect={true} />
            </div>

            <Spin spinning={postageLoading}>
              <div className={styles['postage-box']}>
                {
                  (!!postcodeNotAvailable) &&
                  <div className={styles['error-message']}>Postcode Not Available</div>
                }
                {
                  (!!shippingError) &&
                  <div className={styles['error-message']}>Not available.</div>
                }
                {
                  !!(shippingDistanceError && productDetailData?.inStock) &&
                  <div className={styles['error-message']}>Non-delivery areas. </div>
                }

                <div className={styles['postage-item']}>
                  <div className={styles['title']}>Delivery & Handling: </div>
                  <div className={styles['value']}>
                  {
                      !!postageLoading &&
                      'Calculating...'
                    }
                    {
                      !!(!postageLoading && productDetailData?.enabled && !postageData.postage && postageData.courierId) &&
                      'Free Shipping'
                    }
                    {
                      !!(!postageLoading && !productDetailData?.enabled && !postageData.postage && postageData.courierId) &&
                      'Unavailable'
                    }
                    {
                      !!(!postageLoading && postageData.postage && postageData.courierId) &&
                      formatCurrency(postageData.postage)
                    }
                  </div>
                </div>


                <div className={styles['postage-item']}>
                  <div className={styles['title']}>ETA: </div>
                  <div className={styles['value']}>{!postageLoading && postageData.eta}</div>
                </div>

                {
                  !!(productDetailData && [4, 5, 6].includes(productDetailData?.courierID)) &&
                  <>
                    <div className={styles['postage-item']}>
                      <div className={styles['title']}>Shipping Carrier: International Registered Post</div>
                    </div>
                    
                    <div className={styles['postage-item']}>
                      <div className={styles['title']}>Ships from and sold by globaloutlet.com</div>
                    </div>
                  </>
                }
              </div>
            </Spin>

            {/* {
              (productDetailData?.courierID && [3, 5, 10].includes(productDetailData.courierID)) &&
              <div className={styles['help-line']} onClick={handleShowCombineModal}>
                <ShippingSave style={{ width: '24px'}}></ShippingSave>
                <div className={styles['shipping-save-text']}>Combine Shipping & Save</div>
                Help
                <IconHelp style={{ width: '16px', cursor: 'pointer', marginLeft: '6px' }}></IconHelp>
              </div>
            } */}

            {
              showCombineModal &&
              <Modal
                title=""
                width={700}
                centered
                footer={null}
                open={showCombineModal}
                onCancel={handleCancelCombineModal}
              >
                <div className={styles['combine-model']}>
                  <div className={styles['model-title']}>Save Money on Your Orders, Combine Shipping!</div>

                  <div className={'margin-top-8'}>
                    Why not grab more than one item and save on shipping? To take advantage, just add two or more products to your shopping cart.<br/>
                      (<strong>Products eligible for combined shipping are marked</strong>

                    <ShippingSave style={{ width: '24px', verticalAlign: 'sub' }}></ShippingSave>
                    <span className={styles['shipping-save-text']}>as Combine Shipping &amp; Save</span>
                    ).
                  </div>
                  <div className={'margin-top-8'}>
                    After you have finished shopping, proceed to checkout to see how much you have saved on shipping.
                  </div>
                  <p>
                    Simply finalise payment on your order! Remember, there are greater savings to be had by purchasing multiple eligible products!
                  </p>
                  <div className={'margin-top-8'}>
                    <strong>Terms &amp; Conditions:</strong>
                    <ul>
                        <li>If your order also contains items that are not eligible for Combined Shipping, you will be charged normal shipping rates on those items.</li>
                        <li>If any discount offer on shipping fees are used on eligible items such as a coupon discount code, the item in question will not be eligible for any further shipping discounts.</li>
                        <li>Actual savings will vary depending on the weight of the item and it&#039;s category.</li>
                    </ul>
                  </div>
                  <div className={'margin-top-8'}>
                    <strong>FAQ</strong>
                    <p>Why am I unable to receive any discounts when purchasing two or more products that are eligible for combined shipping?</p>
                    <p>We have 2 exceptions to the combine shipping system:</p>
                    <ul>
                        <li>a) Due to minimum charges set by courier companies, there may be no additional shipping discount for individual items weighing less than 0.5kg.</li>
                        <li>b) Items shipped via DHL / UPS or regular mail can only be combined with multiple of the exact same product to receive a combined shipping discount.</li>
                    </ul>
                  </div>
                </div>
              </Modal>
            }
          </div>
        }

        {/* csotd tips */}
        {
          !!(displayPurposesOnly && productDetailData?.features)
          &&
          <div className={styles['csotd-tips-box']}>
            <div dangerouslySetInnerHTML={{ __html: productDetailData?.features }} />
          </div>
        }

        {/* question按钮 */}
        <div className={styles['question-btn']}>
          <div className={styles['norton-box']}>
            <Image
              alt={'norton'}
              width={112}
              height={27}
              src={`${imageDomain}/product-detail/norton-logo.png`} />
          </div>
          <Link 
            href={`/contact-us?q1=Product%20Enquiries&q2=A1&productID=${productDetailData?.productID}`}
            passHref
            legacyBehavior
          >
            <a className={styles['ask-question']} rel="noopener noreferrer">
              Ask a question ?
            </a>
          </Link>
        </div>
      </div>
      {
        isWholesaleOpen && 
        <Wholesale 
          onClose={closeWholesale}
          isWholesaleOpen={isWholesaleOpen}
          productID={productDetailData?.productID}
          productUrl={`${apiDomain}${productDetailData?.url}`}
        />
      }

      {
        isNotifyMeOpen &&
        <NotifyMe 
          onClose={closeNotifyMe}
          isWholesaleOpen={isNotifyMeOpen}
          productID={productDetailData?.productID}
          goodsName={productDetailData?.name}
        />
      }

      <AddToCartSuccessModal showAddToCartModal={showAddToCartModal} setShowAddToCartModal={setShowAddToCartModal} />
    </div>
  )
}